import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function RolePermissions() {
  const [catalog, setCatalog] = useState([]);
  const [roles, setRoles] = useState([]);

  const load = async () => {
    const r = await api.get("/role-permissions");
    setCatalog(r.data.catalog || []);
    setRoles(r.data.roles || []);
  };
  useEffect(() => { load(); }, []);

  const toggle = (role, perm) => {
    setRoles((rs) => {
      const exists = rs.find((x) => x.role === role);
      if (!exists) return [...rs, { role, permissions: [perm] }];
      const has = exists.permissions.includes(perm) || exists.permissions.includes("*");
      const next = has ? exists.permissions.filter((p) => p !== perm && p !== "*") : [...exists.permissions, perm];
      return rs.map((x) => x.role === role ? { ...x, permissions: next } : x);
    });
  };
  const toggleAll = (role) => {
    setRoles((rs) => {
      const exists = rs.find((x) => x.role === role);
      if (!exists) return [...rs, { role, permissions: ["*"] }];
      const isAll = exists.permissions.includes("*");
      return rs.map((x) => x.role === role ? { ...x, permissions: isAll ? [] : ["*"] } : x);
    });
  };

  const save = async (role) => {
    const r = roles.find((x) => x.role === role);
    try {
      await api.put("/role-permissions", { role, permissions: r?.permissions || [] });
      toast.success(`Role ${role} disimpan`);
    } catch (e) { toast.error("Gagal simpan"); }
  };

  const has = (role, p) => {
    const r = roles.find((x) => x.role === role);
    return r?.permissions.includes("*") || r?.permissions.includes(p);
  };

  const roleNames = ["admin", "supervisor", "kasir"];

  return (
    <div className="p-6 lg:p-10">
      <div className="mb-6">
        <div className="overline text-zinc-500">KONTROL AKSES</div>
        <h1 className="font-display font-black text-4xl tracking-tighter">Role & Permission</h1>
        <p className="mt-2 text-sm text-zinc-500 max-w-xl">Atur menu/fitur apa yang dapat diakses oleh tiap role. Berubah seketika untuk seluruh pengguna baru. Pengguna existing akan tetap memakai permission individu.</p>
      </div>
      <div className="border border-border overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-zinc-50 border-b border-border"><tr>
            <th className="text-left p-3 overline">Permission</th>
            {roleNames.map((r) => <th key={r} className="text-center p-3 overline uppercase">{r}</th>)}
          </tr></thead>
          <tbody>
            <tr className="border-b border-border bg-zinc-50">
              <td className="p-3 font-semibold">Semua Akses (* )</td>
              {roleNames.map((r) => (
                <td key={r} className="p-3 text-center">
                  <input type="checkbox" checked={!!roles.find(x=>x.role===r)?.permissions.includes("*")} onChange={() => toggleAll(r)} data-testid={`perm-all-${r}`}/>
                </td>
              ))}
            </tr>
            {catalog.map((p) => (
              <tr key={p} className="border-b border-border">
                <td className="p-3 font-mono text-xs">{p}</td>
                {roleNames.map((r) => (
                  <td key={r} className="p-3 text-center">
                    <input type="checkbox" checked={has(r, p)} onChange={() => toggle(r, p)} data-testid={`perm-${r}-${p}`}/>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="bg-zinc-50">
              <td></td>
              {roleNames.map((r) => (
                <td key={r} className="p-3 text-center">
                  <button onClick={() => save(r)} data-testid={`perm-save-${r}`} className="text-xs font-semibold border border-zinc-900 px-3 py-1.5 hover:bg-zinc-900 hover:text-white">Simpan {r}</button>
                </td>
              ))}
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}
